"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = DataAdd;
var _DataAdd = require("@adobe/react-spectrum-workflow/dist/DataAdd.js");
var _icon = require("@react-spectrum/icon");
var _react = _interopRequireDefault(require("react"));
function DataAdd(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_DataAdd.A4uDataAdd, null));
}